export default __webpack_public_path__ + "static/media/rfid_checkout.150bc060.png";